import { sortBy } from '../../util/arrays';
import { dt } from '../../util/dateTime';
import { AMOUNT_BY_MONTH_FORMAT, UNKNOWN_MERCHANT_ID } from './constants';
import {
    BaseSpendingGroup,
    CashflowTransactionEntry,
    SpendingGroupBy,
} from './types';

export const buildBaseSpendingGroups = ({
    transactionEntries,
    groupBy,
}: {
    transactionEntries: CashflowTransactionEntry[];
    groupBy: SpendingGroupBy;
}): BaseSpendingGroup[] => {
    const spendingGroups: Record<string, BaseSpendingGroup> = {};

    for (const transactionEntry of transactionEntries) {
        if (
            transactionEntry.category.categoryGroup.supercategory !==
                'SPENDING' ||
            transactionEntry.isHidden
        ) {
            continue;
        }

        const id =
            groupBy === 'category'
                ? transactionEntry.category.id
                : groupBy === 'categoryGroup'
                  ? transactionEntry.category.categoryGroup.id
                  : transactionEntry.merchant?.id || UNKNOWN_MERCHANT_ID;

        if (!spendingGroups[id]) {
            spendingGroups[id] = {
                id,
                name:
                    groupBy === 'category'
                        ? transactionEntry.category.name
                        : groupBy === 'categoryGroup'
                          ? transactionEntry.category.categoryGroup.name
                          : transactionEntry.merchant?.name ||
                            'Unknown Merchant',
                amount: 0,
                amountByMonth: {},
                category: transactionEntry.category,
                merchant: transactionEntry.merchant,
            };
        }

        const month = dt(transactionEntry.date).format(AMOUNT_BY_MONTH_FORMAT);

        if (!spendingGroups[id].amountByMonth[month]) {
            spendingGroups[id].amountByMonth[month] = 0;
        }

        spendingGroups[id].amount += transactionEntry.amount;
        spendingGroups[id].amountByMonth[month] += transactionEntry.amount;
    }

    return sortBy(Object.values(spendingGroups), 'amount', 'ASC');
};
